<template>
    <div class="tools">
        <new-ledger></new-ledger>
        <div class="header">
            <h1>快速操作</h1>
            <span class="view-all" @click="$router.push({name: 'bizShortCut'})">查看全部</span>
        </div>
        <div class="content">
            <div class="list" @click="$router.push({name: 'bizAddHouse'})">
                刊登廣告
                <img src="@/assets/img/icon/arrow_right_gray_biz.svg" alt="" srcset="">
            </div>
            <div class="list" @click="newLedger">
                新增記帳
                <img src="@/assets/img/icon/arrow_right_gray_biz.svg" alt="" srcset="">
            </div>
            <div class="list" @click="$router.push({name: 'bizNewTask'})">
                新增委託
                <img src="@/assets/img/icon/arrow_right_gray_biz.svg" alt="" srcset="">
            </div>
            <div class="list"  @click="$router.push({name: 'bizAddLandlord'})">
                建立房東
                <img src="@/assets/img/icon/arrow_right_gray_biz.svg" alt="" srcset="">
            </div>
            <div class="list" @click="$router.push({name: 'bizReportOverview'})">
                報表概覽
                <img src="@/assets/img/icon/arrow_right_gray_biz.svg" alt="" srcset="">
            </div>
            <div class="list" @click="$router.push({name: 'bizBookingMgtDefault'})">
                簽署合約
                <img src="@/assets/img/icon/arrow_right_gray_biz.svg" alt="" srcset="">
                <span class="todo-count" v-if="todoBookingCount">{{todoBookingCount}}</span>
            </div>
            <div class="list" @click="$router.push({name: 'bizBatchUpload'})">
                批次刊登廣告
                <img src="@/assets/img/icon/arrow_right_gray_biz.svg" alt="" srcset="">
            </div>
            <div class="list" @click="$router.push({name: 'bizNewPaperContract'})">
                建立紙本合約
                <img src="@/assets/img/icon/arrow_right_gray_biz.svg" alt="" srcset="">
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    methods: {
        newLedger: function () {
            this.$analyticsBiz.logEvent('新增記帳', { screen_name: '新增記帳'})
            this.$router.push({name: 'bizNewLedger'})
        },
    },
    computed: {
        ...mapGetters({
            todoBookingCount: 'BIZ_TODO_LIST_BOOKING_COUNT',
        })
    },
    components: {
    }
}
</script>
<style lang="scss">
    .tools{
        padding: 24px;
        width: 100%;
        height: 360px;
        box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
        border: solid 1px #f3f3f3;
        background-color: #ffffff;
        border-radius: 6px;
        box-sizing: border-box;
        .header{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 28px;
            h1{
                font-size: 20px;
            }
            .view-all{
                cursor: pointer;
                color: #ff9275;
            }
        }
        .content{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .list{
                position: relative;
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 176px;
                height: 50px;
                font-size: 16px;
                font-weight: 500;
                padding: 12px 12px 13px 15px;
                margin-bottom: 20px;
                border-radius: 4px;
                border: solid 1px #f3f3f3;
                background-color: #ffffff;
                box-sizing: border-box;
                cursor: pointer;
                .todo-count{
                    right: 36px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/personalHome/home/toolsList/toolsList.vue